import { render, staticRenderFns } from "./SecurityEmail.vue?vue&type=template&id=cb02abc8&lang=pug&"
import script from "./SecurityEmail.vue?vue&type=script&lang=js&"
export * from "./SecurityEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports